var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRight = function SvgRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.989 2.274v19.452a1 1 0 0 0 1.517.855l16.069-9.725a1 1 0 0 0 0-1.712L4.506 1.419a1 1 0 0 0-1.517.855",
    className: "right_svg__right"
  })));
};
export { SvgRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZwogICAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjQgMjQiPgogICA8dGl0bGU+YXJyb3ctYnV0dG9uLXJpZ2h0LTI8L3RpdGxlPgogICAgPHBhdGggY2xhc3M9InJpZ2h0IiBkPSJNMi45ODksMi4yNzRWMjEuNzI2YTEsMSwwLDAsMCwxLjUxNy44NTVsMTYuMDY5LTkuNzI1YTEsMSwwLDAsMCwwLTEuNzEyTDQuNTA2LDEuNDE5QTEsMSwwLDAsMCwyLjk4OSwyLjI3NFoiLz4KPC9zdmc+";